import { mapState, mapActions } from "vuex";
import { getSelectData, GetDefaultItem } from "@/api/common.js";
import roomApi from "../../api/room.js";
import searchPopup from "@/components/searchPopup";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import "@/utils/longpress";
const mixin = {
  data() {
    return {
      roomTypeData: [],
      roomStatusData: [],
      visible: {
        roomUpdate: false,
      },
      searchData: {
        endDate: "",
        startDate: "",
        roomType: "",
        roomStatus: 0,
        keyWords: "",
        sortModel: 0,
      },
      roomOptions: {},
      defaultItem: {},
      isSmallView: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  mounted() {
    this.roomStatusData = [
      {
        Id: "1",
        Code: "EmptyClean",
        Text: "空净",
      },
      {
        Id: "2",
        Code: "EmptyDirty",
        Text: "空脏",
      },
      {
        Id: "3",
        Code: "CheckInClean",
        Text: "住净",
      },
      {
        Id: "4",
        Code: "CheckInDirty",
        Text: "住脏",
      },
      {
        Id: "5",
        Code: "Repair",
        Text: "维修",
      },
      {
        Id: "9",
        Code: "Lock",
        Text: "封房",
      },
      {
        Id: "6",
        Code: "Stop",
        Text: "停用",
      },
      {
        Id: "7",
        Code: "Arrivals",
        Text: "预抵",
      },
      {
        Id: "8",
        Code: "Departure",
        Text: "预离",
      },
    ];
  },

  methods: {
    ...mapActions(["setRoomInfo"]),
    //获取系统参数值
    getDefaultItem() {
      return new Promise((resolve, reject) => {
        GetDefaultItem({})
          .then(res => {
            this.defaultItem = {
              PriceCodeId: res.Data.PriceCodeId,
              isShowTime: res.Data.RoomStatusModel == "0",
              IsIndependentPriceCode: res.Data.IsIndependentPriceCode,
              IsHoldTotalPrice: res.Data.IsHoldTotalPrice,
              ...res.Data.CustomCircleSign,
            };
            res.Data.DoorlockConfigList.forEach(item => {
              this.defaultItem[item.Code] = item.Value;
            });
            res.Data.SystemConstList.forEach(item => {
              this.defaultItem[item.Code] = item.Value;
            });
            res.Data.TimeList.forEach(item => {
              this.defaultItem[item.Code] = item.Value;
            });
            this.isSmallView =
              this.defaultItem.RealTimeRoomStatusSize == 0 ||
              this.defaultItem.RealTimeRoomStatusSize == 2;
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    getSearchPopup(type) {
      const that = this;
      const AccountDate = this.user.AccountDate;
      let roomFilterCnt = [
        {
          label: "房型",
          name: "roomType",
          type: "buttonSelect",
          props: {
            valueField: "Id",
            textField: "Text",
            defaultValue: this.searchData.roomType,
          },
          data: this.roomTypeData,
        },
        {
          label: "房态",
          name: "roomStatus",
          type: "buttonSelect",
          props: {
            valueField: "Id",
            textField: "Text",
            defaultValue: this.searchData.roomStatus,
          },
          data: this.roomStatusData,
        },
      ];
      let title = "实时房态";
      if (type == 1) {
        title = "房态日历";
        roomFilterCnt.unshift({
          label: "房态日期",
          name: "date",
          type: "dateRange",
          props: {
            min: moment(AccountDate)
              .add(-10, "y")
              .format("YYYY-MM-DD"),
            max: moment(AccountDate)
              .add(10, "y")
              .format("YYYY-MM-DD"),
            defaultValue: [this.searchData.startDate, this.searchData.endDate],
          },
        });
        roomFilterCnt.push({
          label: "按楼层",
          name: "sortModel",
          type: "buttonSelect",
          props: {
            valueField: "Id",
            textField: "Text",
            defaultValue: this.searchData.sortModel,
          },
          data: [
            {
              Id: "1",
              Text: "按楼层",
            },
          ],
        });
      } else if (type == 2) {
        roomFilterCnt.unshift({
          label: "是否显示当天预离",
          name: "isShowLeaving",
          type: "buttonSelect",
          props: {
            valueField: "Id",
            textField: "Text",
            defaultValue: this.isShowLeaving,
          },
          data: [
            {
              Id: "1",
              Text: "是",
            },
            {
              Id: "0",
              Text: "否",
            },
          ],
        });
      }
      searchPopup({
        title: title,
        styles: {
          width: "90%",
        },
        content: roomFilterCnt,
        submit: values => {
          that.handleSearch(values);
        },
      });
    },
    setSearchValue(values) {
      if (values && values.roomType && values.roomType.length) {
        this.searchData.roomType = values.roomType;
      } else {
        this.searchData.roomType = "";
      }
      if (values && values.roomStatus && values.roomStatus.length) {
        this.searchData.roomStatus = values.roomStatus;
      } else {
        this.searchData.roomStatus = 0;
      }
      this.searchData.sortModel = values.sortModel || 0;
      this.getRoomData(() => this.onSearch());
    },
    /**关键字搜索 */
    onSearch() {
      // this.getRoomData();
    },
    /**房间状态设置 */
    roomSetting(dItem) {
      this.visible.roomUpdate = true;
      this.roomInfo = dItem;
    },
    /**查看订单详情 */
    checkDetail(item) {
      this.$router.push({ name: "OrderDetail", query: { id: item.OrderId } });
    },
    /**获取搜索数据，包括房型数据和房间状态数据 */
    getSearchSelectData() {
      //获取房型
      getSelectData({
        Types: "roomtype,RoomStatusColor",
      }).then(res => {
        this.roomTypeData = res.Data.roomtype;
        this.baseRoomStatusColorData = res.Data.RoomStatusColor.filter(
          item =>
            item.Code != "TempLeave" &&
            item.Code != "Booking" &&
            item.Code != "CheckOut",
        );
      });
      //获取房间状态
      // getSelectData({
      //   Types: "RoomStatusColor"
      // }).then(res => {
      //   this.roomStatusData = res.Data.RoomStatusColor;
      // });
    },
    /**
     * 清空时间
     */
    clearDate() {
      this.checkedDateArray = [];
      this.isEmptyRoomCheck = false;
      this.$nextTick(() => {
        const array = this.$refs.mainContent.querySelectorAll(".room-checked");
        for (let i = 0; i < array.length; i++) {
          this.$common.removeClass(array[i], "room-checked");
        }
      });
      this.disabled.reserve = true;
      this.disabled.checkIn = true;
    },
    /**查看房间日志 */
    checkRoomLog(roomId) {
      this.$router.push({
        name: "RoomLog",
        query: {
          Id: roomId,
        },
      });
    },
    /**预定/入住 */
    roomOrder(type, status) {
      const roomList = cloneDeep(this.checkedDateArray);
      roomList.forEach((el, index) => {
        let startDate = el.date[0];
        const now = moment(this.user.AccountDate).format("YYYY-MM-DD");
        const isBeforeToday = moment(el.date[0], "YYYY-MM-DD").isBefore(now);
        let inTime = this.defaultItem.ArrivalsTime;
        if (type == "checkin") {
          inTime =
            now == moment().format("YYYY-MM-DD") && !isBeforeToday
              ? moment().format("HH:mm")
              : this.defaultItem.ArrivalsTime;
        }
        let endDate =
          el.date.length &&
          moment(el.date[el.date.length - 1])
            .add(1, "d")
            .format("YYYY-MM-DD");
        const params = {
          CheckInTime: startDate,
          CheckOutTime: endDate,
          RoomTypeId: el.roomTypeId,
        };
        roomApi.GetRoomAvailable(params).then(res => {
          el.roomNoList = res.Data.RoomNos;
          el.daterange = [startDate, endDate];
          el.baseDaterange = [startDate, endDate];
          el.price = "";
          el.Persons = [];
          el.TransactionPrices = [];
          el.BaseTransactionPrices = [];
          el.inTime = inTime;
          el.outTime = this.defaultItem.DepartureTime;
          el.priceStructure = "";
          el.OrderStatus = type == "checkin" ? "1" : "0";
          el.disabled = {
            disabledStart: type == "checkin",
            disabledEnd: false,
          };
          if (index == roomList.length - 1) {
            setTimeout(() => {
              this.roomOptions.gridData = roomList;
              this.roomOptions.actionType = type;
              this.roomOptions.jumpToName =
                status == 1 ? "RoomStatus" : "TodayRoom";
              this.setRoomInfo(this.roomOptions);
              this.$router.push({ name: "RoomOrder" });
            }, 300);
          }
        });
      });
    },
  },
};

export { mixin };
